import { tns } from '../translationNamespace'
import { OwnershipType } from '@unreserved-frontend-v2/api/generated/graphql/types'

export const OWNERSHIP_TYPE = [
  { label: tns + ':condo', value: OwnershipType.Condo },
  { label: tns + ':freehold', value: OwnershipType.Freehold },
]

export const OWNERSHIP_TYPE_LABELS: Record<OwnershipType, string> = OWNERSHIP_TYPE.reduce(
  (memo, item) => ({ ...memo, [item.value]: item.label }),
  {} as Record<OwnershipType, string>
)
